<div class="action-arrow__content">
	<a
     class="action-icon action-icon-active"
     title="edit Client"
     (click)="onEditClient()">
		<i class="fas fa-edit active"></i>
	</a>
    <a
	 title="delete Client"
	 class="action-icon action-icon-active"
	 (click)="onDeleteClient()">
		<i class="fas fa-trash active"></i>
	</a>
</div>
